import Helper from './Helper';

class Gri {
  constructor() {
    this.link = document.querySelectorAll('td.link span');
    this.parentTable;
    this.parentCol;
    this.parentTD;
    this.prevSibling;
    this.siblingContent;
    this.linkContent;

    if(this.link.length > 0){
      this.bindEventsOnLoad();
    }

  }
  /*
    * Concat links and text, remove last td
    * */
   bindEventsOnLoad(){
    this.link.forEach((item) => {
      this.parentTable = Helper.getClosest(item, 'table');
      this.parentTD = Helper.getClosest(item, 'td');
      this.prevSibling = this.parentTD.previousElementSibling;
      this.siblingContent = this.prevSibling.querySelector('span');
      this.linkContent = this.parentTD.querySelector('span');

      if (this.linkContent.innerHTML.indexOf('[[') >= -1){
        let articleID = this.linkContent.innerHTML;
        let articleIDshort = articleID.substr(2,articleID.length-4);
        articleIDshort = articleIDshort.substring(0, articleIDshort.indexOf(']'));
        Helper.addClass(this.parentTD, 'js-modified')
        this.parentTD.remove();
        Helper.addClass(this.parentTable, 'js-modified')
      }
      if (this.linkContent.innerHTML.indexOf('?p=') !== -1 || this.linkContent.innerHTML.indexOf('http://') !== -1 || this.linkContent.innerHTML.indexOf('https://') !== -1 || this.linkContent.innerHTML.indexOf('https://my.nswow.ch/wow') !== -1) {
        if (this.linkContent.innerHTML.indexOf('?p=') !== -1) {
          const newatag = document.createElement("a");
          newatag.setAttribute('href', this.linkContent.textContent);
          newatag.innerHTML = this.siblingContent.innerHTML;
          this.siblingContent.innerHTML = '';
          this.siblingContent.appendChild(newatag);
        } else if (this.linkContent.innerHTML.indexOf('https://my.nswow.ch/wow') !== -1){
          // PDF
          let linkItem;
          let text = this.linkContent.innerText;
          const newatag = document.createElement("a");
          newatag.setAttribute('target', '_blank');

          if(text.indexOf('#') != -1){
            let anchorName = text.split('#');
            linkItem = '#'+anchorName[1];
          } else {
            let text = this.linkContent.innerHTML;
            if(text){
              let reg = /(["'])((?:\\\1|.)*?)\1/gi;
              let textArr = text.match(reg);
              if(textArr){
                linkItem = textArr[0].split('"')[1];
              } else {
                linkItem = this.linkContent.innerHTML;
              }
            }
          }
          newatag.setAttribute('href', linkItem);
          newatag.innerHTML = this.siblingContent.innerHTML;
          this.siblingContent.innerHTML = '';
          this.siblingContent.appendChild(newatag);
        } else if (this.linkContent.innerHTML.indexOf('http://') !== -1 || this.linkContent.innerHTML.indexOf('https://') !== -1) {
          const newatag = document.createElement("a");
          newatag.setAttribute('href', this.linkContent.textContent);
          newatag.setAttribute('target', '_blank');
          newatag.innerHTML = this.siblingContent.innerHTML;
          this.siblingContent.innerHTML = '';
          this.siblingContent.appendChild(newatag);
        } else {
          const newatag = document.createElement("a");
          newatag.setAttribute('href', 'http://' + this.linkContent.textContent);
          newatag.setAttribute('target', '_blank');
          newatag.innerHTML = this.siblingContent.innerHTML;
          this.siblingContent.innerHTML = '';
          this.siblingContent.appendChild(newatag);
        }
        Helper.addClass(this.parentTD, 'js-modified')
        this.parentTD.remove();
        Helper.addClass(this.parentTable, 'js-modified')
      }
    });
  }
}
export default Gri;
